// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* ToastDemo.css */\r\n/* Solid border */\r\nhr.solid {\r\n  border-top: 3px solid #007ad9;\r\n}\r\n.toast-demo button {\r\n    min-width: 10rem;\r\n    margin-right: .5rem;\r\n}\r\n\r\n@media screen and (max-width: 960px) {\r\n    .toast-demo button {\r\n        width: 100%;\r\n        margin-bottom: .5rem;\r\n    }\r\n}\r\n              ", ""]);
// Exports
module.exports = exports;
